import Sort from 'lib/psfs/Sort'

export const createMyJobDataViewFilters = () => ({
  filterPanelOpen: false,
  paginationLimit: 20,
  densePadding: false,
  site: 0,
  locusGroups: [],
  locuses: [],
  dataFields: [
    'job',
    'job_task',
    'job_input',
    'date',
    'job_number',
    'locus_group',
    'locus',
    'job_input_type',
    'result',
    'last_edited_by',
  ],
  jobs: [],
  jobTasks: [],
  jobInputs: [],
  jobInputTypes: [],
  sorting: {
    jobId: Sort.DESC,
  },
})

export const isParentLookupInputsFilledIn = (parents, evtInputs, inputId) =>
  Boolean(
    parents?.every(
      ({ inputs }) =>
        inputs &&
        Array.isArray(inputs) &&
        (!inputId || inputs[inputs.length - 1] === inputId) &&
        inputs.every(input =>
          evtInputs?.find(
            ({ input: inputId, result }) =>
              input === inputId && (result || result === 0),
          ),
        ),
    ),
  )

export const DEFAULT_JOBS_FILTERS = {
  workflows: [],
  creators: [],
  triggerRules: [],
  assignees: [],
  locusesAndGroups: [],
}
